import axios from 'axios';
import {
  MainProjectDataModel,
  MainProjectDocumentModel,
} from 'app/edozvola/cases/case-main-project-documents/model/case-main-project-documents.model';
import { FileUploadModel } from 'app/shared/file-upload/model/file-upload.model';
import { FileWrapper } from 'app/shared/model/shared.model';

export const saveMainProjectData = async (idCase: string, mainProjectData: MainProjectDataModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/main-project-document/main-project-data/${idCase}`, mainProjectData)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getMainProjectData = async (idCase: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/main-project-document/main-project-data/${idCase}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveMainProjectDocument = async (idCase: string, mainProjectDocument: MainProjectDocumentModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/main-project-document/${idCase}`, mainProjectDocument)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchMainProjectDocuments = async ({ signal, pagination, uuid, caseInPreview }): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(
        `api/main-project-document/find-all/${uuid}?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}&caseInPreview=${caseInPreview}`,
        {
          signal: signal,
        },
      )
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.error);
      });
  });
};

export const deleteMainProjectDocument = async (idMainProjectDocument: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/main-project-document/${idMainProjectDocument}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getMainProjectDocument = async (idMainProjectDocument: string): Promise<MainProjectDocumentModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/main-project-document/${idMainProjectDocument}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyMainProjectDocument = async (idMainProjectDocument: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/main-project-document/copy/${idMainProjectDocument}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const moveMainProjectDocumentUp = async (idMainProjectDocument: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/main-project-document/move-up/${idMainProjectDocument}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const moveMainProjectDocumentDown = async (idMainProjectDocument: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/main-project-document/move-down/${idMainProjectDocument}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const uploadMainProjectDocumentFile = async (idMainProjectDocument: string, file: FileUploadModel): Promise<any> => {
  const formData: FormData = new FormData();

  formData.append('file', file.file);
  formData.append('fileName', file.fileName);
  formData.append('uuid', file.uuid);

  return await new Promise((resolve, reject) => {
    axios
      .post(`api/main-project-document/files/${idMainProjectDocument}`, formData)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchMainProjectDocumentAttachments = async (
  idMainProjectDocument: string,
  page: number,
  size: number,
  column: string,
  direction: string,
  caseInPreview: boolean,
): Promise<any> => {
  if (idMainProjectDocument) {
    return await new Promise(resolve => {
      axios
        .get(
          `api/main-project-document/files/find-all/${idMainProjectDocument}?page=${page}&size=${size}&column=${column}&direction=${direction}&caseInPreview=${caseInPreview}`,
        )
        .then(response => resolve(response.data));
    });
  }
};

export const deleteMainProjectDocumentAttachment = async (idMainProjectDocumentAttachment: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/main-project-document/files/delete-attachment/${idMainProjectDocumentAttachment}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const updateMainProjectDocumentAttachmentStatus = async (idMainProjectDocumentAttachment: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/main-project-document/files/update-status/${idMainProjectDocumentAttachment}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const previewMainProjectDocumentAttachment = async (idMainProjectDocumentAttachment: number): Promise<FileWrapper> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/main-project-document/files/preview-attachment/${idMainProjectDocumentAttachment}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyMainProjectDocuments = async (caseUuid: string, caseUuidToCopyFrom: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/main-project-document/copy/${caseUuid}/${caseUuidToCopyFrom}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getMainProjectDocumentVariant = async (caseUuid: string, caseInPreview: boolean): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/main-project-document-variant?caseInPreview=${caseInPreview}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
